import {Component, Input, OnInit} from '@angular/core';
import {ConnecttocrudService} from '../../../connecttocrud.service';
import {CamundaService} from '../../../camunda.service';
import {LeftpanelComponent} from '../../../leftpanel/leftpanel.component';

@Component({
  selector: 'app-approval-form',
  templateUrl: './approval-form.component.html',
  styleUrls: ['./approval-form.component.scss']
})
export class ApprovalFormComponent implements OnInit {


  usersData: any;
  workFlowTasks: any;
  userColumns = [];
  entityMappingToSortApplications = [];

  @Input() formAttributes: any;

  @Input() partner: string;
  @Input() account: string;
  @Input() entity: string;
  @Input() version: string;
  @Input() partnerKey: string;

  componentLoading = true;

  constructor(private _service: ConnecttocrudService, private camunda: CamundaService, public platform: LeftpanelComponent) { }

  async ngOnInit() {

    for (const formAttribute of this.formAttributes) {
      if (formAttribute.required) {
        this.userColumns.push(formAttribute.displayName);
        this.entityMappingToSortApplications.push(formAttribute.attributeName);
      }
    }

    this.getUserTasks();


  }

  getUserTasks() {
      this.componentLoading = true;

      this.camunda.getWorkflowTasks('assignee=' + this.partner + '.' + localStorage.getItem('signInEmail')).subscribe(
          async items => {
              this.workFlowTasks = items;
              await this.getFormVariables();
              this.componentLoading = false;
          },
          error => {
          }
      );
  }

  getPayloadForTask(taskId) {
      return new Promise(async (resolve, reject) => {
          this.camunda.getTaskFormVariables(taskId, 'variableNames=payload&deserializeValues=true').subscribe(
              items => {
                  const payload = items['payload']['value']['consumerDetails'];
                  if (payload && this.formAttributes.length > 0) {
                      payload['taskId'] = taskId;
                      payload['approvalLoading'] = false;
                      payload['rejectLoading'] = false;
                      this.usersData.push(payload);
                  }
                  resolve('success');
              },
              error => {
                  resolve('failed');
              }
          );
      });
  }

  getFormVariables() {
      return new Promise(async (resolve, reject) => {
          const promises = [];
          this.usersData = [];

          for (const task of this.workFlowTasks) {
              promises.push(this.getPayloadForTask(task.id));
          }

          Promise.all(promises)
              .then(async (results) => {
                  resolve('success');
              });
      });
  }

  showRejectButton(user) {
    if (user.status === 'pending') {
      return true;
    } else {
      return false;
    }
  }

  showApproveButton(user) {
    if (user.status === 'pending') {
      return true;
    } else {
      return false;
    }
  }

  approveUser(task) {

      const id = task['taskId'];

      task.approvalLoading = true;
      this.camunda.completeUserTask(id, {'variables': {'userApproved': {'value': true, 'type': 'Boolean', 'valueInfo': {}}}}).subscribe(
          items => {
              task.approvalLoading = false;
              this.platform.openSnackBar('User approved successfully.', 'Success', {
                  duration: 10000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
              });
              this.getUserTasks();
          },
          error => {
              task.approvalLoading = false;
              this.platform.openSnackBar('Error.', 'Error', {
                  duration: 10000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
              });
          }
      );
  }

  rejectUser(task) {

      const id = task['taskId'];
      task.rejectLoading = true;
      this.camunda.completeUserTask(id, {'variables': {'userApproved': {'value': false, 'type': 'Boolean', 'valueInfo': {}}}}).subscribe(
          items => {
              task.rejectLoading = false;
              this.platform.openSnackBar('User Rejected successfully.', 'Success', {
                  duration: 10000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
              });
              this.getUserTasks();
          },
          error => {
              task.rejectLoading = false;
              this.platform.openSnackBar('Error.', 'Error', {
                  duration: 10000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
              });
          }
      );
  }
}
